import Text, { type TextProps } from '@builder4/shared/components/Text';
import { InspectorText } from '@/components/inspector/InspectorText/InspectorText';
import { ROOT_NODE, type Node, type NodeHelpersType } from '@craftjs/core';
import { type Editor } from 'slate';
import type { SlateEditorType } from '@builder4/shared/types/text';
import { useState } from 'react';
import { useEditorRegistry } from '@/hooks/useEditorRegistry';
import { getBreakpointProp } from '@builder4/shared/utils/breakpointUtils';
import type { ContainerProps } from '@builder4/shared/components/Container';
import { useMixpanel } from '@/hooks/useMixpanel';
import { EVENT } from '@/analytics/mixpanel';

type EditorEntry = {
  editor: SlateEditorType;
  selection: Editor['selection'];
};

export const editorRegistry = new Map<string, EditorEntry>();

const EditorText = (props: Partial<TextProps>) => {
  const [id, setId] = useState<string | undefined>(undefined);
  const [editor, setEditor] = useState<SlateEditorType | undefined>(undefined);
  const track = useMixpanel();
  //keeping hook for now
  useEditorRegistry(editor, id);

  const handleSlateEditorInit = (id: string, editor: SlateEditorType) => {
    setId(id);
    setEditor(editor);
  };

  const handleTextEdited = () => {
    track(EVENT.TEXT_EDITED);
  };

  return (
    <Text {...props} onSlateEditorInit={handleSlateEditorInit} onTextEdited={handleTextEdited} />
  );
};

EditorText.craft = {
  ...Text.craft,
  rules: {
    canDrag: (node: Node, helpers: NodeHelpersType) => {
      if (node.data.custom.isLocked) return false;
      const breakpoint = helpers(ROOT_NODE).get().data.props.breakpoint || 'desktop';
      const position = getBreakpointProp(
        node.data.props as Partial<ContainerProps>,
        'position',
        breakpoint,
      );

      return position === 'relative' || position === 'sticky';
    },
  },
  related: {
    toolbar: InspectorText,
  },
};

export default EditorText;
